(function () {
  if (window.__mrblueUiKitReady) return;
  window.__mrblueUiKitReady = true;

  var STORAGE_KEY = 'mrblue-theme';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* ignore */
    }
  }

  function initThemeToggle() {
    var saved = 'dark';
    try {
      saved = localStorage.getItem(STORAGE_KEY) || 'dark';
    } catch (e) {
      /* ignore */
    }
    setTheme(saved);

    document.querySelectorAll('[data-mrblue-theme-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-theme') || 'dark';
        setTheme(current === 'dark' ? 'light' : 'dark');
      });
    });
  }

  function initAiLoader() {
    var globalLoader = document.getElementById('mrblue-ai-loader');
    if (!globalLoader) return;

    function showLoader(text) {
      var label = globalLoader.querySelector('.mrblue-ai-loader__text');
      if (label && text) label.textContent = text;
      globalLoader.hidden = false;
      globalLoader.classList.add('is-active');
    }

    function hideLoader() {
      globalLoader.classList.remove('is-active');
      globalLoader.hidden = true;
    }

    document.addEventListener(
      'click',
      function (event) {
        var checkout = event.target.closest('[name="checkout"], .cart__checkout-button, a[href*="/checkout"]');
        if (checkout) showLoader('Loading checkout…');
      },
      true
    );

    document.querySelectorAll('.loading-overlay').forEach(function (overlay) {
      var observer = new MutationObserver(function () {
        var loading = !overlay.classList.contains('hidden') && overlay.offsetParent !== null;
        if (loading) showLoader('Loading…');
        else hideLoader();
      });
      observer.observe(overlay, { attributes: true, attributeFilter: ['class', 'style'] });
    });

    window.addEventListener('pageshow', hideLoader);
  }

  function initShader(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var time = 0;
    var animationId = 0;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      canvas.width = Math.floor(rect.width * dpr);
      canvas.height = Math.floor(rect.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function blob(x, y, radius, color) {
      var gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
      gradient.addColorStop(0, color);
      gradient.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2);
      ctx.fill();
    }

    function draw() {
      var width = canvas.clientWidth;
      var height = canvas.clientHeight;
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = '#0f172a';
      ctx.fillRect(0, 0, width, height);

      blob(
        width * 0.25 + Math.sin(time * 0.012) * 40,
        height * 0.35 + Math.cos(time * 0.01) * 30,
        width * 0.45,
        'rgba(45, 212, 191, 0.55)'
      );
      blob(
        width * 0.72 + Math.cos(time * 0.011) * 35,
        height * 0.28 + Math.sin(time * 0.013) * 25,
        width * 0.38,
        'rgba(56, 189, 248, 0.5)'
      );
      blob(
        width * 0.55 + Math.sin(time * 0.009) * 28,
        height * 0.72 + Math.cos(time * 0.014) * 20,
        width * 0.42,
        'rgba(134, 239, 172, 0.42)'
      );
      blob(
        width * 0.4 + Math.cos(time * 0.008) * 22,
        height * 0.55 + Math.sin(time * 0.015) * 18,
        width * 0.3,
        'rgba(253, 224, 71, 0.28)'
      );

      time += 1;
      if (!reduceMotion) animationId = window.requestAnimationFrame(draw);
    }

    resize();
    draw();
    window.addEventListener('resize', resize);
  }

  function initShaders() {
    document.querySelectorAll('.mrblue-shader-canvas').forEach(initShader);
  }

  function init() {
    initThemeToggle();
    initAiLoader();
    initShaders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
